export default data => {
    if (data.error) {
        return { error: data.error };
    }
    if (data.matrix) {
        return data.matrix.map(row => {
            return row.map(cell => {
                return cell.response;
            });
        });
    }
    return null;
};



// WEBPACK FOOTER //
// ./services/model/routing/matrixRouting.js